'use client';

import { useScopedI18n } from '@locales/client';
import { useRouter } from 'next/navigation';

import { Box } from '../box';
import { BodyTextBoldSecondary, BoldHeadingSecondary } from '../typography';
import LogoDesktop from '@/shared/assets/logo.svg';
import { Button } from '../form/button';
import { ImageError, BoxMain } from './styles';
import { Link } from '@/shared/ui/link';

export function NotFound() {
  const t = useScopedI18n('common');
  const router = useRouter();

  const goToHome = () => router.push('/');

  return (
    <BoxMain>
      <Link href="/">
        <LogoDesktop />
      </Link>

      <Box $marginTop={64} $marginBottom={32}>
        <ImageError src="/images/background/404.png" height={156} />
      </Box>

      <BoldHeadingSecondary>{t('errors.404')}</BoldHeadingSecondary>

      <Box>
        <Button variant="primary" type="button" onClick={goToHome}>
          <BodyTextBoldSecondary>
            <Box $padding="10px 0">{t('errors.actions.back')}</Box>
          </BodyTextBoldSecondary>
        </Button>
      </Box>
    </BoxMain>
  );
}
